import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'antd';
import { useI18n } from '../i18n/I18nProvider';

export const cacheNavbarDialog = importDialog => {
  let loaded = null;
  let pending = null;
  return () => {
    if (loaded) return Promise.resolve(loaded);
    if (!pending) pending = importDialog().then(module => {
      loaded = module.default;
      return loaded;
    }).catch(error => { pending = null; throw error; });
    return pending;
  };
};

export default function DeferredNavbarDialog({ loadDialog, open, onCancel, title, width, className, ...props }) {
  const { t } = useI18n();
  const [Dialog, setDialog] = useState(null);
  const [loadError, setLoadError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    if (!open || Dialog) return undefined;
    let active = true;
    setLoadError(false);
    loadDialog().then(Component => { if (active) setDialog(() => Component); })
      .catch(() => { if (active) setLoadError(true); });
    return () => { active = false; };
  }, [loadDialog, open, Dialog, attempt]);

  // Keep the loaded dialog mounted on close so AntD can finish its exit animation.
  if (Dialog) return <Dialog {...props} open={open} onCancel={onCancel} />;
  return <Modal open={open} onCancel={onCancel} footer={null} centered title={title} width={width} className={className}>
    <p role={loadError ? 'alert' : 'status'}>
      {loadError ? t('nav.dialogLoadFailed', 'Unable to load this window. Retry or close it.') : t('nav.dialogLoading', 'Loading…')}
    </p>
    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
      {loadError && <Button onClick={() => setAttempt(value => value + 1)}>{t('nav.retryDialog', 'Retry')}</Button>}
      <Button onClick={onCancel}>{t('nav.cancelDialog', 'Cancel')}</Button>
    </div>
  </Modal>;
}
